import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { NzAvatarModule } from 'ng-zorro-antd/avatar';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';
import { Board, BoardBackend, BoardType } from '../../../core/board/board';
import { BoardFuncs } from '../../../core/board/board.func';
import { AppColor } from '../../../shared/color/color';
import { TeamIconComponent } from '../team-icon/team-icon.component';

@Component({
  selector: 'app-board-icon',
  standalone: true,
  imports: [CommonModule, NzIconModule, NzAvatarModule, NzToolTipModule, TeamIconComponent],
  templateUrl: './board-icon.component.html',
  styleUrl: './board-icon.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BoardIconComponent {
  Color = AppColor;
  BoardTypeBackend = BoardType;

  @Input() board?: Board | BoardBackend;

  @Input() hideUserStatus = true;
  @Input() ringColor?: string;
  @Input() showTooltip = false;

  @Input() size = 30;
  ringSize = '2px';

  tooltip() {
    return this.isRemoved() ? `${BoardFuncs.getName(this.board)} has left the workspace` : undefined;
  }

  get boardName() {
    return BoardFuncs.getName(this.board);
  }

  styleForUserContainer() {
    const style = {} as CSSStyleDeclaration;

    style.width = `${this.size}px`;
    style.height = `${this.size}px`;

    if (this.ringColor) {
      style.borderWidth = this.ringSize;

      style.borderRadius = '50%';
      style.borderStyle = 'solid';
      style.boxSizing = 'content-box';
      style.borderColor = this.ringColor;
    }

    return style;
  }

  get sizeForDot() {
    return '5px';
  }

  shouldDisplayUserStatus() {
    if (this.isRemoved()) {
      return false;
    }
    return !this.hideUserStatus;
  }

  /*
   * MARK - Remove
   */

  shouldDisplayRemoved() {
    if (this.hideUserStatus) {
      return false;
    }

    return this.isRemoved();
  }

  isRemoved() {
    return BoardFuncs.isRemoved(this.board);
  }

  leaveStyle() {
    const style = {} as CSSStyleDeclaration;
    style.height = '20px';
    style.width = '20px';
    style.right = '-2px';
    style.bottom = '-2px';
    style.borderRadius = '50%';
    style.backgroundColor = 'grey';
    return style;
  }

  sizeForLeaveIcon() {
    return '5px';
  }

  /*
   * MARK - Tag
   */

  colorForTag() {
    if (!this.board) {
      ('');
    }
    // return this.tagService.getTag(this.board!.representTo!.id)!.colorName;
  }

  sizeForTagIcon() {
    return '10px';
  }

  styleForTagContainer(): CSSStyleDeclaration {
    const style = {} as CSSStyleDeclaration;
    style.borderRadius = '5px';
    style.backgroundColor = 'lighten(AppColor[this.colorForTag()!], 20%)';
    return style;
  }
}
